<div class="flow-wrapper">
  @if (!hideGlobalMessages) {
    @for (message of messages; track message) {
      <div class="ui message"
        [ngClass]="message.type"
        [attr.dataTestid]="'ui/message/' + message.id">
        {{message.text}}
      </div>
    }
  }
  @if (flowFormGroup) {
    <form
      class="ui form"
      [class.error]="hasNodeErrors"
      [class.success]="hasNodeSuccessMessages"
      [formGroup]="flowFormGroup"
      (ngSubmit)="onSubmit($event)">
      @for (node of uiNodes; track node; let nodeIndex = $index) {
        <!-- anchor type -->
        @if (node.attributes.node_type === 'a') {
          <a
            [class.ui]="prominentActions"
            [class.primary]="prominentActions"
            [class.button]="prominentActions"
            [class.flow-action-link]="prominentActions"
            [href]="$any(node.attributes).href"
          [attr.dataTestid]="'node/anchor/' + $any(node.attributes).id">{{getNodeLabel(node)}}</a>
        }
        <!-- input type -->
        @if (node.attributes.node_type === 'input') {
          <app-form-input
            [class.form-action]="prominentActions && ($any(node.attributes).type === 'submit' || $any(node.attributes).type === 'button')"
            [class.hidden-input]="$any(node.attributes).type === 'hidden' && node.messages.length === 0"
            [isFormSubmitting]="isSubmitting"
            [form]="flowFormGroup"
            [nodeId]="nodeIds[nodeIndex]"
          [node]="node"></app-form-input>
        }
        <!-- image type -->
        @if (node.attributes.node_type === 'img') {
          <img
            [attr.dataTestid]="'node/image/' + $any(node.attributes).id"
            [src]="$any(node.attributes).src"
            [alt]="$any(node.attributes).meta.label?.text">
        }
        <!-- text type -->
        @if (node.attributes.node_type === 'text' && $any(node.attributes).text.id === 1050015) {
          <p class="text-meta-label" [attr.dataTestid]="'node/text/' + $any(node.attributes).id + '/label'">
            {{node.meta.label?.text}}
          </p>
          <div class="fields" [attr.dataTestid]="'node/text/' + $any(node.attributes).id + '/text'">
            @for (secret of $any(node.attributes).text.context.secrets; track secret) {
              <div class="four wide column field"
                [attr.key]="secret.k"
                [attr.dataTestid]="'node/text/'+$any(node.attributes).id+'/lookup_secret'">
                <code>{{secret.text.id === 1050014 ? "Used" : secret.text.text}}</code>
              </div>
            }
          </div>
        }
        <!-- text type 2 -->
        @if (node.attributes.node_type === 'text' && $any(node.attributes).text.id !== 1050015) {
          <div class="horizontalScrollable-container">
            <pre>{{$any(node.attributes).text.text}}</pre>
          </div>
        }
        @if (node.attributes.node_type !== 'input') {
          @for (message of node.messages; track message; let messageIndex = $index) {
            <div
              class="ui message"
              [class.error]="message.type === 'error'"
              [class.info]="message.type === 'info'"
              [class.success]="message.type === 'success'"
              [id]="nodeIds[nodeIndex] + '-message-' + messageIndex"
              [attr.role]="message.type === 'error' ? 'alert' : 'status'"
              [attr.dataTestid]="'node/message/' + nodeIndex + '/' + message.id">
              {{message.text}}
            </div>
          }
        }
      }
      @if (isCaptchaVisible) {
        <app-turnstile formControlName="captchaToken" />
      }
    </form>
  }
</div>
